import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export let searchCustomerCompetitor = async(searchValues,pageValues) => {
  const api = APIEndpoint.SEARCH_CUSTOMER_COMPETITOR_API;
  
  let payload = {
    requestObject : {
      factoryName : searchValues.factoryName,
      countryId: searchValues.countryId,
      customerGroupByRegion: searchValues.customerGroupByRegion,
      competitorType: searchValues.competitorType,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };
  const res = await axiosInstance.post(api, payload);
  
  return res;
}

export const createCompetitor = async (request) => {
  const payload = {
    objectValue: request,
  };
  const api = APIEndpoint.CREATE_CUSTOMER_COMPETITOR_API;
  const res = await axiosInstance.post(api, JSON.stringify(payload));

  return res;
};

export const getCompetitorById = async(id,type) => {
  const url = `${APIEndpoint.GET_CUSTOMER_COMPETITOR_BY_ID_API}`;

  const res = await axiosInstance.get(url + "/" + id + `&=` + type)
  return res;
}

export const updateCustomerCompetitor = async (request) => {
  const payload = {
    requestObject: request,
  };
  const url = `${APIEndpoint.PUT_UPDATE_CUSTOMER_COMPETITOR}`;

  const res = await axiosInstance.put(url, JSON.stringify(payload));
  return res;
};